import { roles } from "../static/data";

export const getCamelCaseWord = (word) => {
  if (!word) return "";

  return String(word)
    .replace(/_/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
};

export const hardcodedViolations = {
  "Filled out only once from IP address ?": true,
  "Webcam enabled ?": true,
  "Mouse always in assessment window ?": true,
};

// Define colors for each metric
export const metricColors = {
  engagement: "#C4A6FF",
  stress: "#FFCF74",
  confidence: "#CCE8A0",
  interest: "#8BDBCD",
  boredom: "#FFA8A8",
};

// Function to extract content of the body tag from the full HTML document
export function extractBodyContent(html) {
  const bodyStart = html.indexOf("<body>") + 6;
  const bodyEnd = html.indexOf("</body>");
  return html.substring(bodyStart, bodyEnd);
}
export function stripHTML(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

export function updateHtmlWithBodyContent(html, newBodyContent) {
  if (!/<body[^>]*>/i.test(html)) {
    // If no <body> tag is found, wrap the content in <body>
    return `<body>${newBodyContent}</body>`;
  }

  return html.replace(
    /<body[^>]*>[\s\S]*<\/body>/i,
    `<body>${newBodyContent}</body>`
  );
}

export const isHighResolution = () => {
  // Get the screen resolution
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;

  // Check if either width or height is above 1400x1050
  return screenWidth > 1368 || screenHeight > 768;
};

export const getStageColor = (stage = "") => {
  const colors = [
    {
      name: "New Application Recieved",
      color: "#FFB200",
    },
    {
      name: "screening",
      color: "primary.main",
    },
    {
      name: "Invited",
      color: "primary.main",
    },
    {
      name: "Interviewed",
      color: "#FFB200",
    },
    {
      name: "Withdraw",
      color: "#FF5B5B",
    },
    {
      name: "Rejected",
      color: "#FF5B5B",
    },
    {
      name: "Interview result generated",
      color: "purple.main",
    },
    {
      name: "Offer Sent",
      color: "#FFB200",
    },
    {
      name: "Hired",
      color: "#FFB200",
    },
  ];

  return (
    colors.find((c) => c?.name?.toLowerCase().includes(stage?.toLowerCase()))
      ?.color || "#FFB200"
  );
};

export const getRandomColor = (() => {
  let colorIndex = 0;
  const colors = [
    "#9B65EC",
    "#3EB958",
    "#5294EC",
    "#FFC64A",
    "#F44336",
    "#FF5722",
    "#009688",
    "#673AB7",
    "#4CAF50",
    "#E91E63",
    "#795548",
    "#00BCD4",
    "#CDDC39",
    "#FF9800",
    "#607D8B",
  ];

  // Shuffle colors initially to reduce repetition
  const shuffledColors = colors.sort(() => Math.random() - 0.5);

  return () => {
    const color = shuffledColors[colorIndex % shuffledColors.length];
    colorIndex++;
    return color;
  };
})();

export const endReasonMessages = {
  "Candidate attempted complete interview.": {
    title: "Interview Completed",
    description:
      "The candidate successfully completed the entire interview. The results will be generated and displayed accordingly.",
    canGenerateResult: true,
  },
  "Interview ended by Getgeek.": {
    title: "Interview Ended by Getgeek",
    description:
      "The interview was ended due to candidate behavior, such as repeatedly providing irrelevant answers or not actively engaging. The results will be generated based on the valid responses submitted.",
    canGenerateResult: true,
  },

  "Candidate left the interview in between.": {
    title: "Interview Left Midway",
    description:
      "The candidate exited the interview before completing it. The results will still be generated based on the completed portion.",
    canGenerateResult: true,
  },
  "Interview ended due to network issues.": {
    title: "Internet Connectivity Issue",
    description:
      "The assessment could not be completed due to an unstable internet connection on the candidate’s side. A stable connection is required to proceed without disruptions.",
    canGenerateResult: false,
  },
  "Interview ended because of user inactivity.": {
    title: "Interview Timed Out",
    description:
      "The interview ended because the candidate was inactive for a prolonged period. The results will still be generated based on the attempted part.",
    canGenerateResult: true,
  },
};

export const formatTimeRemaining = (milliseconds) => {
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );

  if (days > 0) {
    console.log(`Expires in ${days} days, ${hours} hours`);
  } else {
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
    console.log(`Expires in ${hours} hours, ${minutes} minutes`);
  }
};

export const permissionMap = {
  "Create, edit, delete job postings": "manageJobPostings",
  "Create & conduct assessments": "manageAssessments",
  "Share candidates results": "shareResults",
  "Invite team members (all roles)": "inviteMembers",
  "Import & manage candidates": "manageCandidates",
  "Full recruitment pipeline access": "pipelineAccess",
  "Manage billing & settings": "billingAndSettings",

  "View job postings": "viewJobPostings",
  "View assessments": "viewAssessments",
  "View candidates results": "viewResults",
  "View recruitment pipeline": "viewPipeline",
};

export const generatePermissionsObject = (role) => {
  const rolePermissions = roles[role]?.permissions || [];

  const allPermissionKeys = Object.values(permissionMap);
  const activePermissions = rolePermissions.map((p) => permissionMap[p]);

  const permissionsObject = {};
  allPermissionKeys.forEach((key) => {
    permissionsObject[key] = activePermissions.includes(key);
  });

  return permissionsObject;
};
